module.exports = __webpack_public_path__ + "static/assets/19ba897f4750e853a4529fff08cf95b9.gif";